export enum ProcessEngineTask {
    CONFIRM_BUSINESS_RELATIONSHIP = 'create_business_relationship_confirmation',
    CREATE_ACCOUNT = 'create_account',
    CREATE_ACCOUNT_PROSPECT = 'create_account_prospect',
    CREATE_EBANKING_CONTRACT = 'create_ebanking',
    CREATE_NO_INTEREST = 'create_no_interest',
    CREATE_POWER_OF_ATTORNEY = 'create_power_of_attorney',
    DELETE_ACCOUNT = 'delete_account',
    DELETE_ACCOUNT_CATEGORY = 'delete_account_category',
    DELETE_CARD = 'delete_card',
    DELETE_EBANKING_CONTRACT = 'delete_ebanking',
    DELETE_EMAIL = 'delete_customer_email',
    DELETE_PHONE = 'delete_customer_phone',
    DELETE_POWER_OF_ATTORNEY = 'delete_power_of_attorney',
    MODIFY_ACCOUNT_CATEGORY = 'modify_account_category',
    MODIFY_ADDRESS = 'modify_customer_address',
    MODIFY_CARD_LIMIT = 'modify_card_limit',
    MODIFY_CIVIL_STATUS = 'modify_customer_civil_status',
    MODIFY_EMAIL = 'modify_customer_email',
    MODIFY_NAME = 'modify_customer_name',
    MODIFY_PHONE = 'modify_customer_phone',
    NOTIFICATION_RESPONSE = 'create_notification_response',
    ORDER_CARD = 'create_card',
}
